/**
 * KAN-940: черновик сообщения клиенту в localStorage под ключом
 * composer-draft:<draftKey>. Только текст (фото не хранится). Хранилище может
 * быть недоступно (приватный режим, запрет сайта): любые ошибки глотаются,
 * поле ввода работает как без черновика.
 */

const PREFIX = 'composer-draft:';

export function composerDraftStorageKey(draftKey: string): string {
  return `${PREFIX}${draftKey}`;
}

/** Сохранённый черновик или пустая строка. */
export function readComposerDraft(draftKey: string | undefined): string {
  if (!draftKey) return '';
  try {
    return localStorage.getItem(composerDraftStorageKey(draftKey)) ?? '';
  } catch {
    return '';
  }
}

/** Пишет черновик; пустой текст убирает ключ. */
export function writeComposerDraft(draftKey: string | undefined, text: string): void {
  if (!draftKey) return;
  try {
    const key = composerDraftStorageKey(draftKey);
    if (text) localStorage.setItem(key, text);
    else localStorage.removeItem(key);
  } catch {
    // Хранилище недоступно: черновик просто не сохраняется.
  }
}

/** Ключ черновика сообщения клиенту (поле ввода переписки карточки). */
export function clientMessageDraftKey(clientId: string): string {
  return `client:${clientId}`;
}

/**
 * KAN-944: ключ несохранённого комментария клиента (useAutosaveText с draftKey):
 * текст лежит, пока сохранение не прошло, и виден, если клиента взял другой менеджер.
 */
export function clientCommentDraftKey(clientId: string): string {
  return `comment:${clientId}`;
}
